module.exports = __webpack_public_path__ + "static/goal-071495270722eb220aed106cb667eb32.png";